<div>
  <h2 class="text-primary">Erfolgreich abgemeldet</h2>
</div>
<div>
  <h4 class="text-color-secondary">Sie wurden erfolgreich ausgeloggt.</h4>
</div>
<div class="mt-4">
  <p-button icon="pi pi-sign-in" label="Zurück zur Anwendung" (onClick)="backToApp()"></p-button>
</div>
